const styles = {
  deleteMessageText: {
    color: '#4C4E64',
    fontSize: '14px',
    marginTop: '8px'
  },
};

export default styles;
